var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropUpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_12707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 18.3335C14.6002 18.3335 18.3335 14.6002 18.3335 10.0002C18.3335 5.40016 14.6002 1.66683 10.0002 1.66683C5.40016 1.66683 1.66683 5.40016 1.66683 10.0002C1.66683 14.6002 5.40016 18.3335 10.0002 18.3335ZM10.0002 8.3335L13.3335 11.6668L6.66683 11.6668L10.0002 8.3335Z",
    fill: "#75757C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_12707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 -1 20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropUpCircle);
export default __webpack_public_path__ + "static/media/arrowDropUpCircle.7a30e270838b0720ba49c1bfef0bfbe0.svg";
export { ForwardRef as ReactComponent };